var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Admin, CustomRoutes, Resource, } from "react-admin";
import { useContext, useEffect, useState } from "react";
import { ElectionEventBaseTabs } from "./resources/ElectionEvent/ElectionEventBaseTabs";
import { CreateAreaContest } from "./resources/AreaContest/CreateAreaContest";
import { CreateBallotStyle } from "./resources/BallotStyle/CreateBallotStyle";
import { CreateCandidate } from "./resources/Candidate/CreateCandidate";
import { CreateContest } from "./resources/Contest/CreateContest";
import { CreateDocument } from "./resources/Document/CreateDocument";
import { ElectionEventList } from "./resources/ElectionEvent/ElectionEventList";
import { ListArea } from "./resources/Area/ListArea";
import { ListAreaContest } from "./resources/AreaContest/ListAreaContest";
import { ListBallotStyle } from "./resources/BallotStyle/ListBallotStyle";
import { ListCandidate } from "./resources/Candidate/ListCandidate";
import { ListContest } from "./resources/Contest/ListContest";
import { ListDocument } from "./resources/Document/ListDocument";
import { ListElection } from "./resources/Election/ListElection";
import { ListTenant } from "./resources/Tenant/ListTenant";
import { Messages } from "./screens/Messages";
import { Navigate, Route } from "react-router-dom";
import { ShowDocument } from "./resources/Document/ShowDocument";
import { UserAndRoles } from "./screens/UserAndRoles";
import buildHasuraProvider from "ra-data-hasura";
import { customBuildQuery } from "./queries/customBuildQuery";
import { fullAdminTheme } from "./services/AdminTheme";
import { SettingsScreen } from "./screens/SettingsScreen";
import { ListUsers } from "./resources/User/ListUsers";
import { CustomLayout } from "./components/CustomLayout";
import { EditBallotStyle } from "./resources/BallotStyle/EditBallotStyle";
import { EditAreaContest } from "./resources/AreaContest/EditAreaContest";
import { EditTenant } from "./resources/Tenant/EditTenant";
import { CreateTenant } from "./resources/Tenant/CreateTenant";
import { CreateElection } from "./resources/Election/CreateElection";
import { ElectionBaseTabs } from "./resources/ElectionEvent/ElectionBaseTabs";
import { CandidateBaseTabs } from "./resources/Candidate/CandidateBaseTabs";
import { ContestBaseTabs } from "./resources/Contest/ContestBaseTabs";
import { SettingsElectionsTypesCreate } from "./resources/Settings/SettingsElectionsTypesCreate";
import { adminI18nProvider } from "./services/AdminTranslation";
import { useTranslation } from "react-i18next";
import { ApolloContext } from "./providers/ApolloContextProvider";
import cssInputLookAndFeel from "@/atoms/css-input-look-and-feel";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useAtomValue } from "jotai";
import ListScheduledEvents from "./resources/ScheduledEvents/ListScheduledEvent";
import Notifications from "./resources/Notifications/Notifications";
import { TemplateEdit } from "./resources/Template/TemplateEdit";
import { TemplateList } from "./resources/Template/TemplateList";
import { TemplateCreate } from "./resources/Template/TemplateCreate";
import ListReports from "./resources/Reports/ListReports";
import { SelectTenant } from "./screens/SelectTenant";
import { AuthContext } from "./providers/AuthContextProvider";
import { customSortData } from "./lib/helpers";
import { UpsertArea } from "./resources/Area/UpsertArea";
var StyledApp = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "customCss"; },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var customCss = _a.customCss;
    return customCss;
});
export var StyledAppAtom = function (_a) {
    var children = _a.children;
    var css = useAtomValue(cssInputLookAndFeel);
    return (_jsx(StyledApp, { className: "styled-app-atom", customCss: css, children: children }));
};
// This function builds and wraps your Hasura data provider.
export var buildWrappedHasuraProvider = function (apolloClient) { return __awaiter(void 0, void 0, void 0, function () {
    var options, buildGqlQueryOverrides, dataProviderHasura, wrappedDataProvider;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                options = {
                    client: apolloClient,
                    buildQuery: customBuildQuery,
                };
                buildGqlQueryOverrides = {};
                return [4 /*yield*/, buildHasuraProvider(options, buildGqlQueryOverrides)
                    // Override the getList method to apply custom sort logic.
                ];
            case 1:
                dataProviderHasura = _a.sent();
                wrappedDataProvider = __assign(__assign({}, dataProviderHasura), { getList: function (resource, params) {
                        return dataProviderHasura.getList(resource, params).then(function (response) {
                            // Create a new sort object ensuring proper literal types for order.
                            var sortedData = response.data;
                            // params.sort is undefined for non well defined list column fields (ex: FunctionFields )
                            if (params.sort) {
                                var sort = {
                                    field: params.sort.field,
                                    order: params.sort.order === "DESC" ? "DESC" : "ASC",
                                };
                                sortedData = customSortData(response.data, sort);
                            }
                            return { data: sortedData, total: response.total };
                        });
                    } });
                return [2 /*return*/, wrappedDataProvider];
        }
    });
}); };
var App = function () {
    var apolloClient = useContext(ApolloContext).apolloClient;
    var _a = useState(null), dataProvider = _a[0], setDataProvider = _a[1];
    var _b = useTranslation(), i18n = _b.i18n, t = _b.t;
    adminI18nProvider.changeLocale(i18n.language);
    i18n.on("languageChanged", function (lng) { return adminI18nProvider.changeLocale(lng); });
    var isAuthenticated = useContext(AuthContext).isAuthenticated;
    useEffect(function () {
        var buildDataProvider = function () { return __awaiter(void 0, void 0, void 0, function () {
            var wrappedProvider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, buildWrappedHasuraProvider(apolloClient)];
                    case 1:
                        wrappedProvider = _a.sent();
                        setDataProvider(wrappedProvider);
                        return [2 /*return*/];
                }
            });
        }); };
        buildDataProvider();
    }, []);
    if (!dataProvider)
        return _jsx("p", { children: t("loadingDataProvider") });
    return (_jsx(StyledAppAtom, { children: _jsxs(Admin, { dataProvider: dataProvider || undefined, layout: CustomLayout, theme: fullAdminTheme, i18nProvider: adminI18nProvider, children: [_jsxs(CustomRoutes, { children: [_jsx(Route, { path: "/", element: _jsx(Navigate, { to: "/sequent_backend_election_event", replace: true }), index: true }), _jsx(Route, { path: "/tenant", element: _jsx(SelectTenant, {}) }), _jsx(Route, { path: "/user-roles", element: _jsx(UserAndRoles, {}) }), _jsx(Route, { path: "/messages", element: _jsx(Messages, {}) }), _jsx(Route, { path: "/settings/*", element: _jsx(SettingsScreen, {}) })] }), _jsx(Resource, { name: "sequent_backend_election_event", list: ElectionEventList, edit: ElectionEventBaseTabs, show: ElectionEventBaseTabs, options: { label: "Election Events", isMenuParent: true } }), _jsx(Resource, { name: "sequent_backend_election_type", create: SettingsElectionsTypesCreate, edit: SettingsScreen, show: SettingsScreen, options: { label: "Election Type", isMenuParent: true } }), _jsx(Resource, { name: "sequent_backend_election", list: ListElection, create: CreateElection, show: ElectionBaseTabs, edit: ElectionBaseTabs, options: {
                        label: "Elections",
                        menuParent: "sequent_backend_election_event",
                        foreignKeyFrom: "election_event_id",
                    } }), _jsx(Resource, { name: "sequent_backend_contest", list: ListContest, create: CreateContest, edit: ContestBaseTabs, show: ContestBaseTabs, options: {
                        label: "Contests",
                        menuParent: "sequent_backend_election",
                        foreignKeyFrom: "election_id",
                    } }), _jsx(Resource, { name: "sequent_backend_candidate", list: ListCandidate, create: CreateCandidate, edit: CandidateBaseTabs, show: CandidateBaseTabs, options: {
                        label: "Candidates",
                        menuParent: "sequent_backend_contest",
                        foreignKeyFrom: "contest_id",
                    } }), _jsx(Resource, { name: "sequent_backend_ballot_style", edit: EditBallotStyle, list: ListBallotStyle, create: CreateBallotStyle, options: { label: "Ballot Styles" } }), _jsx(Resource, { name: "sequent_backend_certificate_authority" }), _jsx(Resource, { name: "sequent_backend_area", edit: UpsertArea, list: ListArea, create: UpsertArea, options: { label: "Area" } }), _jsx(Resource, { name: "sequent_backend_area_contest", edit: EditAreaContest, list: ListAreaContest, create: CreateAreaContest, options: { label: "Area Contest" } }), _jsx(Resource, { name: "sequent_backend_tenant", edit: EditTenant, list: ListTenant, create: CreateTenant, options: { label: "Customer" } }), _jsx(Resource, { name: "sequent_backend_document", show: ShowDocument, list: ListDocument, create: CreateDocument, options: { label: "Document" } }), _jsx(Resource, { name: "sequent_backend_notification", edit: Notifications, list: Notifications, options: { label: "Notifications" } }), _jsx(Resource, { name: "sequent_backend_template", edit: TemplateEdit, list: TemplateList, create: TemplateCreate, options: { label: "Templates" } }), _jsx(Resource, { name: "sequent_backend_scheduled_event", edit: ListScheduledEvents, list: ListScheduledEvents, options: { label: "Scheduled Events" } }), _jsx(Resource, { name: "sequent_backend_report", list: ListReports, create: ListReports, edit: ListReports, options: { label: "Reports" } }), _jsx(Resource, { name: "user", edit: UpsertArea, list: ListUsers, options: { label: "Users" } })] }) }));
};
export default App;
var templateObject_1;
